import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nf404',
  templateUrl: './nf404.component.html',
  styleUrls: ['./nf404.component.css']
})
export class Nf404Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// E:/Project/posSystem/src/app/pos/home/nf404/nf404.component.ts